import { createPluginFactory, ELEMENT_LINK } from '@udecode/plate';
import { Editor, Text } from 'slate';

import { matchUrls } from 'scripts/presentation/components/lib/linkify_it';

export const MARK_URL_HIGHLIGHT = 'url-highlight';

// Highlights bare URLs in the editor via Slate `decorate`, which styles matched ranges without changing the
// document. URLs inside a real ELEMENT_LINK are skipped.
export function createUrlHighlightPlugin() {
  return createPluginFactory({
    key: MARK_URL_HIGHLIGHT,
    isLeaf: true,
    decorate: editor => nodeEntry => decorateUrls(editor, nodeEntry),
  })();
}

function decorateUrls(editor, [node, path]) {
  if (!Text.isText(node) || !node.text) {
    return [];
  }

  // Text inside a real link node belongs to the link plugin — don't highlight it too.
  if (Editor.above(editor, { at: path, match: n => n.type === ELEMENT_LINK })) {
    return [];
  }

  const matches = matchUrls(node.text);

  return matches.map(match => ({
    [MARK_URL_HIGHLIGHT]: true,
    anchor: { path, offset: match.index },
    focus: { path, offset: match.lastIndex },
  }));
}
